import { useEffect, useMemo, useState } from 'react';
import { NAMI_SDK_STATE_KEY } from '../utils/const';

type SdkState = {
  sdkInitialized?: boolean;
  [key: string]: unknown;
};

const SDK_STATE_EVENT = 'nami-sdk-state-changed';

const readSdkInitialized = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const raw = window.localStorage.getItem(NAMI_SDK_STATE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as SdkState;
    return Boolean(parsed?.sdkInitialized);
  } catch (error) {
    console.warn('Unable to read SDK state from storage', error);
    return false;
  }
};

export const dispatchSdkStateChange = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(SDK_STATE_EVENT));
};

export const useSdkInitialized = (): boolean => {
  const [initialized, setInitialized] = useState<boolean>(() => readSdkInitialized());

  useEffect(() => {
    const handleUpdate = () => setInitialized(readSdkInitialized());
    window.addEventListener('storage', handleUpdate);
    window.addEventListener(SDK_STATE_EVENT, handleUpdate);
    return () => {
      window.removeEventListener('storage', handleUpdate);
      window.removeEventListener(SDK_STATE_EVENT, handleUpdate);
    };
  }, []);

  return useMemo(() => initialized, [initialized]);
};
